import { HightouchOrg } from 'modules/dataWarehouse/types';
import { createContext, useContext } from 'react';

type HightouchBillingQueryContextState = {
  hightouchOrg?: HightouchOrg;
  isError: boolean;
  isHightouchEnabled: boolean;
  isLoading: boolean;
};

export const HightouchBillingQueryContext = createContext<
  HightouchBillingQueryContextState | undefined
>(undefined);

export const useHightouchBillingQueryContext = () => {
  const context = useContext<HightouchBillingQueryContextState | undefined>(
    HightouchBillingQueryContext,
  );
  if (context === undefined) {
    throw new Error(
      'useHightouchBillingQueryContext must be used within a HightouchBillingQueryContextProvider',
    );
  }
  return context;
};
